<template>
  <div data-component="blockquote" :data-modifier="data.modifier">
    <blockquote>
      <div class="quote">
        “{{data.quote}}”
      </div>
      <div class="spacers">
        <span class="spacer"></span>
        <span class="spacer"></span>
        <span class="spacer"></span>
        <span class="spacer"></span>
        <span class="spacer"></span>
        <span class="spacer"></span>
        <span class="spacer"></span>
      </div>
      <div class="source">
        <div class="source__name">
          {{data.sourceName}}
        </div>
        <div class="source__info" v-if="data.sourceInfo">
          {{data.sourceInfo}}
        </div>
      </div>
    </blockquote>
  </div>
</template>

<script>
// Module expects:
export default {
  name: 'component_blockquote',
  props: ['data'],
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

blockquote {
  margin: 0;

  .quote {
    margin-bottom: rem(20px);
    @include type('blockquote');
  }

  .source {
    @include type('body');
    
    &__info {
      color: #8B969A;
    }
  }

  .title {
    color: #8B969A;
    line-height: (32/16);
  }

  [data-modifier="big"] & {
    .quote {
      font-size: rem(26px);

      @include mq($bp--tablet, down) {
        font-size: rem(21px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blockquote.vue